import { ArrayParam, NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import React, { useCallback } from 'react';
import _ from 'lodash';
import { useAuth } from '../modules/auth';

const useApiQuery = (params:any = {} ) => {
  const {defaultSortBy} = params;
  const { isBookkeeper } = useAuth();
  const [queryParams, setQueryParams] = useQueryParams({
    page: withDefault(NumberParam, 1),
    pageSize: withDefault(NumberParam, isBookkeeper ? 100: 25),
    sortBy: withDefault(StringParam, defaultSortBy ||  'invoiceDate DESC'),
    search: withDefault(StringParam, ''),
    dateFrom: withDefault(StringParam, ''),
    dateTo: withDefault(StringParam, ''),
    status: withDefault(ArrayParam, undefined),
  });

  const updateQueryParams = useCallback((newQueryParams) => {
    if(!_.isEqual(queryParams, {...queryParams, ...newQueryParams})) {
      setQueryParams(newQueryParams)
    }
  }, [queryParams]);

  const debouncedUpdateQueryParams = React.useCallback(
    _.debounce((newQueryParams: any) => {
      setQueryParams(newQueryParams);
    }, 400),
    [setQueryParams]
  );

  const handleChangeQueryParam = useCallback((param: string) => (value: any) => {
    updateQueryParams({[param]: value || undefined})
  } ,[]);

  return {
    queryParams,
    updateQueryParams,
    debouncedUpdateQueryParams,
    handleChangeQueryParam
  }
};

export default useApiQuery;
